import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { JustifyVariant, TextSwitch } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useCreateColumnContext } from '@/context/CreateColumnContext'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'
import { Help } from '@/components/Help'

import { ColumnDd } from './ColumnDd'
import { Fld, Lbl } from './shared'

export default function FieldLookup() {
  const { id, value, setValue } = useCreateColumnContext()
  const { tables } = useDbClientContext()
  const { table } = useGridV2Context()
  const { t } = useTranslation()

  const lookupConnection = value.lookupOptions.lookupConnColumnId
  const lookupColumn = table?.columns.find((cl) => cl.id === lookupConnection)
  const lookupTableId = lookupColumn?.connections?.fTableId

  const [opts, setOpts] = useState(tables.find((tb) => tb.id === lookupTableId)?.columns || [])

  useEffect(() => {
    if (lookupTableId) {
      const tb = tables.find((tb) => tb.id === lookupTableId)
      if (tb) {
        setOpts(tb?.columns)
      }
    }
  }, [tables, lookupTableId, value.lookupOptions.lookupColumnId])

  return (
    <>
      <Fld>
        <Lbl>Connection</Lbl>
        <ColumnDd
          id={`${id}-lookup-conn`}
          selected={value.lookupOptions.lookupConnColumnId}
          types={[ColumnTypes.Connection]}
          onChange={(opt) => {
            setValue({
              lookupOptions: {
                ...value.lookupOptions,
                lookupConnColumnId: opt.id,
              },
            })
          }}
          //filterOption={filterOption}
          placeholder={t('Select connection')}
        />
      </Fld>

      <Fld>
        <Lbl>Lookup Column</Lbl>
        <ColumnDd
          id={`${id}-lookup-col`}
          excludeTypes={[ColumnTypes.Connection]}
          selected={value.lookupOptions.lookupColumnId}
          onChange={(opt) => {
            setValue({
              lookupOptions: {
                ...value.lookupOptions,
                lookupColumnId: opt.id,
              },
            })
          }}
          options={opts}
          placeholder={t('Select lookup column')}
        />
      </Fld>

      <Fld className='mt-2 mb-4'>
        <Lbl className='flex items-center gap-2'>
          Type{' '}
          <Help
            noPortal
            options={{
              placement: 'right',
            }}
          >
            <Trans>{`Advanced lookup will be statically resolved, useful for query table filtering.`}</Trans>
          </Help>
        </Lbl>
        <TextSwitch
          checked={!value.lookupOptions.standard}
          onClick={(isChecked) => {
            setValue({
              lookupOptions: {
                ...value.lookupOptions,
                standard: !isChecked,
              },
            })
          }}
          textOff={<Trans>Standard</Trans>}
          textOn={<Trans>Advanced</Trans>}
          noColor
          justify={JustifyVariant.Start}
        />
      </Fld>
    </>
  )
}
